import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import usePageTitle from '../../hooks/usePageTitle';
import aboutFeature from '../../assets/images/about-feature.jpg';

export default function About() {
  const { t } = useTranslation();
  usePageTitle(t('about.pageTitle'));
  const values = t('about.values', { returnObjects: true });

  return (
    <>
      <section className="page-hero">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('about.eyebrow')}</span>
            <h1>{t('about.title')}</h1>
            <p className="lede">{t('about.lede')}</p>
          </Reveal>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <div className="feature-grid reverse">
            <Reveal className="feature-media">
              <img src={aboutFeature} alt="A mother holding her baby, smiling" />
            </Reveal>
            <Reveal className="feature-copy" delay={100}>
              <span className="eyebrow">{t('about.whoWeAre')}</span>
              <h2>{t('about.featureTitle')}</h2>
              <p>{t('about.featureBody')}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="two-col">
            <Reveal>
              <h2>{t('about.whyTitle')}</h2>
              <p>{t('about.whyBody1')}</p>
              <p>{t('about.whyBody2')}</p>
            </Reveal>
            <Reveal delay={120}>
              <div className="quote-card">
                <p>{t('about.quote')}</p>
                <footer>{t('about.quoteFooter')}</footer>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <Reveal className="section-head">
            <span className="eyebrow">{t('about.standFor')}</span>
            <h2>{t('about.standForTitle')}</h2>
          </Reveal>
          <div className="value-grid">
            {values.map((v, i) => (
              <Reveal key={v.title} className="value-card" delay={i * 80}>
                <h3>{v.title}</h3>
                <p>{v.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <Reveal className="cta-band">
            <div>
              <h2>{t('about.contactUs')}</h2>
              <p>{t('about.contactBody')}</p>
            </div>
            <div className="cta-actions">
              <Link className="btn btn-primary" to="/register/family">{t('about.iNeedNanny')}</Link>
              <Link className="btn btn-outline" to="/register/nanny">{t('about.iAmNanny')}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
